
<div class="border-0 px-4 py-1 scroll-container" ref="PermissionManagement">
  <p class="page-title mt-3 fs-6 fw-bold">Policy Management</p>

  <!-- Permissions Available Card -->
  <div class="row">
      <div class="col-md-4">
        <div class="card text-white border-0 shadow rounded-5 overview-card-bg responsive-card h-100">
          <div class="card-body d-flex align-items-center gap-3 py-3 px-3 justify-content-between">
            <!-- Text on the left -->
            <div class="d-flex flex-column justify-content-center text-start">
              <p class="mb-1 text-xs text-white">Policies Available</p>
              <p class="m-0 fw-bold text-white">{{ policy_count }}</p>
            </div>
            <!-- Icon on the right -->
            <div class="circular-icon d-flex align-items-center justify-content-center flex-shrink-0 responsive-icon">
              <i class="fas fa-key fa-lg text-primary-blue"></i>
            </div>
          </div>
        </div>
      </div>
    </div>

  <!-- Policy Table Preview -->
  <div class="glassy-table rounded-lg mt-4 border-0 shadow">
    <div class="card-body">

      <!-- Toolbar Row with Assign Button -->
      <div class="d-flex justify-content-end align-items-center mb-2">
        <button class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark" data-bs-toggle="modal" data-bs-target="#create_policy">
            New Policy
          </button>
      </div>

      <!-- GlobalTable -->
      <GlobalTable
        :headers="policy_headers"
        :data="policies"
        table_id="policy_management_table">

        <template #actions="{ row }">
          <div class="d-flex gap-1">
            <button class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark" @click="policy_management(row.id)">Policy Management</button>
            <button class="btn btn-primary-dark btn-sm px-3 shadow-sm text-xxs" @click="delete_policy(row)">Delete Policy</button>
            <button class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark" @click="select_policy(row.id)" data-bs-toggle="modal" data-bs-target="#create_assign">
              Assign
            </button>
          </div>
        </template>

      </GlobalTable>
    </div>
  </div>

</div>

  <!-- create new policy modal -->
  <teleport to="body">
  <div class="modal fade" id="create_policy" tabindex="-1" aria-labelledby="create_user_label" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
        <div class="modal-header border-bottom-0 cute-header shadow-lg">
          <p class="modal-title text-white text-xxs" id="create_user_label">Create Policy</p>
          <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="modal-form-group form-group mb-3">
            <label for="first_name" class="modal-form-label form-label text-xxs">Policy Name:</label>
            <input type="text" v-model="policy_name" class="modal-form-control form-control text-xs rounded-small p-2 shadow-sm text-x" placeholder="Enter Your Policy Name">
            <small class="text-danger p-2 text-xxs fw-bold d-none project-name-messages">Enter your policy name</small>
            <small class="text-danger p-2 text-xxs fw-bold d-none error-messages"></small>
          </div>
          <div class="modal-form-group form-group mb-3">
            <label for="last_name" class="modal-form-label form-label text-xxs">Description:</label>
            <input type="text" v-model="policy_description" class="modal-form-control form-control text-xs rounded-small p-2 shadow-sm text-x" placeholder="Enter The Description">
            <small class="text-danger p-2 text-xxs fw-bold d-none project-description-messages">Enter description</small>
            <small class="text-danger p-2 text-xxs fw-bold d-none error-messages"></small>
          </div>
        </div>
        <div class="modal-footer border-0 p-2 d-flex justify-content-end">
          <button type="submit" class="btn btn-primary-dark btn-sm text-xxs mt-3 text-dark" @click="submit_policy">Create</button>
        </div>
      </div>
    </div>
  </div>
  </teleport>

  <!-- assign modal  -->
   <teleport to="body">
  <div class="modal fade" id="create_assign" tabindex="-1" aria-labelledby="assign_roles_label" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
        <div class="modal-header border-bottom-0 cute-header shadow-lg">
          <p class="modal-title text-white text-xxs" id="assign_roles_label">Assign Role</p>
          <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div v-if="roles.length > 0">
            <GlobalTable
              v-if="roles.length > 0"
              :headers="roles_headers"
              :data="roles"
              table_id="role_management_table">
              <template #actions="{ row }">
                <div class="form-check form-switch">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    :ref="'policy_toggle' + row.id"
                    :checked="is_policy_assigned_to_role(row.id)"
                    @change="toggle_policy_assignment(row.id)"
                    :disabled="loading[row.id]"
                  >
                  <label class="form-check-label text-xxs" :for="'policy-toggle-' + row.id">
                    {{ is_policy_assigned_to_role(row.id) ? 'Assigned' : 'Not Assigned' }}
                  </label>
                </div>
              </template>
            </GlobalTable>
          </div>
          <div v-else>
            <p class="text-xxs text-muted">No roles available to assign.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  </teleport>